import { updateUserPreference } from '@ms-cloudpack/config';
import type { CommandAction } from '../../types/CommandAction.js';
import type { UserPreferences } from '@ms-cloudpack/common-types';

export interface SetArguments {
  key: string;
  value: string;
}

/** Delete a Cloudpack user preference value. */
export const execute: CommandAction<never> = async (params) => {
  const { args } = params;
  const [key, newValue] = args;

  try {
    // Commander should have validated the key based on the given choices, and the update
    // function will also validate its input.
    await updateUserPreference({ key: key as keyof UserPreferences, newValue });
    // Following the pattern of other tools, we don't output anything on success.
    return { message: '' };
  } catch (err) {
    return {
      hasErrors: true,
      message: `Failed to set "${key}": ${(err as Error).message || err}`,
    };
  }
};
